import { render, staticRenderFns } from "./ListCardStats.vue?vue&type=template&id=f4b3245e&"
import script from "./ListCardStats.vue?vue&type=script&lang=js&"
export * from "./ListCardStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports